import React, { ReactElement, Component } from 'react';
import { injectIntl } from 'react-intl';
import { Row, Col, Result, Card } from 'antd';

export const License: React.FC = injectIntl((props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const { intl } = props;
  return (
    <Card className='h-100'>
      <Row>
        <Col span={24}>
          <Result status='warning' title={intl.formatMessage({ id: 'license_invalid' })} extra={[]}></Result>
        </Col>
      </Row>
    </Card>
  );
});
